<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted(){
    // this.setWindow()
  },
  methods:{
    setWindow(){
               //监听用户敲击键盘事件
   window.addEventListener('keydown',this.handleKeydown);
      //阻止右键打开菜单
      document.oncontextmenu = function(event) {
        event.preventDefault();
      };
    },
    handleKeydown(event) {
      //如果键盘敲击f12就阻止f12打开，然后弹框提醒，这个都放在app.vue里面，当然在页面还没有加载的时候最好在index.html里面也加上对应的方法
        if (event.key === 'F12') {
        event.preventDefault(); // 阻止F12的默认行为
        Modal.error({
          title:'警告',
          content:'检测非法调试，F12被管理员禁用',
          okText:'知道了'
        })
      }
    }
  },

};
</script>

<style>
/* 全局样式 */
</style>
